var _a;
import { AccountType, } from '@ally/data-types-afg-accounts';
export var AccountTypeLabel;
(function (AccountTypeLabel) {
    AccountTypeLabel["INTEREST_CHECKING"] = "INTEREST CHECKING";
    AccountTypeLabel["CHECKING"] = "CHECKING";
    AccountTypeLabel["SAVINGS"] = "SAVINGS";
    AccountTypeLabel["CDs"] = "CDs";
    AccountTypeLabel["ROBO_PORTFOLIO"] = "ROBO PORTFOLIO";
    AccountTypeLabel["SELF_DIRECTED"] = "SELF-DIRECTED";
    AccountTypeLabel["WEALTH_MANAGEMENT"] = "WEALTH MANAGEMENT";
    AccountTypeLabel["MORTGAGE"] = "MORTGAGE";
    AccountTypeLabel["HOME_EQUITY"] = "HOME EQUITY";
    // START - CREDIT CARD
    AccountTypeLabel["PLATINUM"] = "PLATINUM";
    AccountTypeLabel["EVERYDAY"] = "EVERYDAY";
    AccountTypeLabel["UNLIMITED"] = "UNLIMITED";
    // END - CREDIT CARD
    AccountTypeLabel["VEHICLE_FINANCING"] = "VEHICLE FINANCING";
})(AccountTypeLabel || (AccountTypeLabel = {}));
export var AccountTypeToLabel = (_a = {},
    _a[AccountType.DDA] = AccountTypeLabel.INTEREST_CHECKING,
    _a[AccountType.MMA] = AccountTypeLabel.SAVINGS,
    _a[AccountType.SDA] = AccountTypeLabel.SAVINGS,
    _a[AccountType.CMG] = AccountTypeLabel.SAVINGS,
    _a[AccountType.CDA] = AccountTypeLabel.CDs,
    _a[AccountType.INVS] = AccountTypeLabel.SELF_DIRECTED,
    _a[AccountType.INVA] = AccountTypeLabel.ROBO_PORTFOLIO,
    _a[AccountType.INVW] = AccountTypeLabel.WEALTH_MANAGEMENT,
    _a[AccountType.MORTGAGE] = AccountTypeLabel.MORTGAGE,
    _a[AccountType.HOME_EQUITY] = AccountTypeLabel.HOME_EQUITY,
    _a[AccountType.PLATINUM] = AccountTypeLabel.PLATINUM,
    _a[AccountType.EVERYDAY] = AccountTypeLabel.EVERYDAY,
    _a[AccountType.UNLIMITED] = AccountTypeLabel.UNLIMITED,
    _a[AccountType.LOAN] = AccountTypeLabel.VEHICLE_FINANCING,
    _a[AccountType.OPERATING_LEASE] = AccountTypeLabel.VEHICLE_FINANCING,
    _a[AccountType.FINANC_LEASE] = AccountTypeLabel.VEHICLE_FINANCING,
    _a[AccountType.HIRE_PURCHASE] = AccountTypeLabel.VEHICLE_FINANCING,
    _a);
//# sourceMappingURL=types.js.map